import type { AnalyticsSalesByTemplate } from "@/@types/Analytics";
import { checkoutTemplateLabel } from "@/utils/checkoutTemplates";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ChartCard } from "./ChartParts";
import { DistributionTile } from "./DistributionTile";

interface TemplateCardsProps {
  salesByTemplate?: AnalyticsSalesByTemplate[];
  isLoading: boolean;
}

export function TemplateCards({ salesByTemplate, isLoading }: TemplateCardsProps) {
  const { t } = useTranslation("reports");
  const rows = useMemo(() => salesByTemplate ?? [], [salesByTemplate]);
  const maxCount = useMemo(() => Math.max(...rows.map((item) => item.count), 1), [rows]);

  return (
    <ChartCard
      title={t("reports:chart_sales_by_template")}
      description={t("reports:chart_sales_by_template_desc")}
      isLoading={isLoading}
      isEmpty={rows.length === 0}
      heightClassName="h-[200px]"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map((item) => (
          <DistributionTile
            key={item.template}
            title={checkoutTemplateLabel(item.template)}
            countPercentage={item.count_percentage}
            barRatio={item.count / maxCount}
            metrics={[
              { label: t("reports:template_sales"), value: item.count },
              { label: t("reports:template_revenue"), value: item.amount_formatted, highlight: true },
              {
                label: t("reports:template_conversion"),
                value: item.initiated_count > 0 ? `${item.conversion_rate.toFixed(1)}%` : "—",
              },
            ]}
          />
        ))}
      </div>
    </ChartCard>
  );
}
